import React from 'react';
import { DataSkeleton, DataSkeletonVariant } from '../states';

interface LoaderProps {
  variant?: DataSkeletonVariant;
  label?: string;
}

const Loader = ({ variant = 'detail', label = 'Carregando conteúdo' }: LoaderProps) => (
  <DataSkeleton variant={variant} rows={5} label={label} />
);

export default Loader;
